import { render, staticRenderFns } from "./ImageName.vue?vue&type=template&id=2a983bb4&scoped=true&"
import script from "./ImageName.vue?vue&type=script&lang=js&"
export * from "./ImageName.vue?vue&type=script&lang=js&"
import style0 from "./ImageName.vue?vue&type=style&index=0&id=2a983bb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a983bb4",
  null
  
)

export default component.exports